module.exports = __webpack_public_path__ + "img/logo-grupo-cometa.9434f7b1.svg";